// extracted by mini-css-extract-plugin
export default {"title":"Rqa-z","warning":"Sqa-z","sizeOptionsLegendText":"Tqa-z"};